import React from 'react';
import { useCreation } from 'ahooks';
import { Box, type BoxProps, CircularProgress, useMediaQuery } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useCustom } from '@/hooks/use-custom';
import { useWebInit } from '@/hooks/use-web-init';
import { Stepper } from '../dev/stepper';
import { Centered } from './centered';
import { Footer } from './footer';
import { Header } from './header';

const FluidBox = styled(Box)<BoxProps>(({ theme }) => ({
  width: '100%',
  padding: 0,
  display: 'grid',
  gridTemplateRows: 'auto 1fr auto',
  gridRowGap: theme.spacing(2),
  gridTemplateColumns: '1fr',
}));

const CenterBox = styled(Box)<BoxProps>(() => ({
  width: '100%',
  padding: 0,
  display: 'flex',
  flexDirection: 'column',
}));

export const AppBox: React.FC<BoxProps> = (props) => {
  const isDownSm = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const { layoutConfig } = useCustom();
  const justifyContent = useCreation(() => {
    return isDownSm ? 'space-between' : layoutConfig?.layout || 'center';
  }, [layoutConfig?.layout, isDownSm]);

  return layoutConfig?.layout !== 'space-between' ? (
    <CenterBox className="h-full min-h-dvh" justifyContent={justifyContent} {...props} />
  ) : (
    <FluidBox className="h-full min-h-dvh" justifyContent={justifyContent} {...props} />
  );
};

export const AppLayout: React.FC<{ children?: React.ReactNode }> = () => {
  const { loading } = useWebInit();

  if (loading) {
    return (
      <Box
        className="min-h-dvh w-full"
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
      >
        <CircularProgress size={24} aria-hidden="true" role="img" />
      </Box>
    );
  }

  return (
    <AppBox>
      <Stepper />
      <Header />
      <Centered />
      <Footer />
    </AppBox>
  );
};
